import { Stack, Text } from '@backyard-ui/core'
import { memo } from 'react'

import { archivedMessageItemWrapper } from './archivedMessageItem.styles'

type Message = {
  id: string
  title: string
  date: string
}

type ArchivedMessageItemProps = {
  data: Message
  onClick: (id: string) => void
  children: string
}

const ArchivedMessageItem = (props: Readonly<ArchivedMessageItemProps>) => {
  const { onClick, data, children } = props

  return (
    <Stack
      direction="column"
      spacing="2"
      data-testid="chat-archivedMessageItem"
      onClick={() => onClick(data.id)}
      className={archivedMessageItemWrapper()}>
      <Stack align="center" justify="space-between">
        <Text color="gray-900" weight="bold" size="md">
          {data.title}
        </Text>
        <Text color="gray-600" size="md">
          {data.date}
        </Text>
      </Stack>
      {children && (
        <Text color="gray-900" size="md">
          {children}
        </Text>
      )}
    </Stack>
  )
}

export default memo(ArchivedMessageItem)
